module.exports = __webpack_public_path__ + "img/select-default.c18f8305.svg";